"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.factory = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var lambda_1 = require("@webnuts/lambda");
var isPascalCase = type_guard_1.isType({ type: 'String', format: 'pascalcase' });
exports.factory = function (args) {
    lambda_1.assert(args, lambda_1.isObject, "\"factory\" expects first argument to be an object, but was given \"" + lambda_1.toTypeString(args) + "\"");
    lambda_1.assert(args.name, isPascalCase, "\"factory\" expects \"name\" on first argument to be a string of Pascal Case, but was given \"" + lambda_1.toTypeString(args.name) + "\"");
    lambda_1.assert(args.settings, lambda_1.isObject, "\"factory\" expects \"settings\" on first argument to be an object, but was given \"" + lambda_1.toTypeString(args.settings) + "\"");
    lambda_1.assert(args.$when, lambda_1.isObject, "\"factory\" expects \"$when\" on first argument to be an object, but was given \"" + lambda_1.toTypeString(args.$when) + "\"");
    for (var _i = 0, _a = Object.entries(args.$when); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        lambda_1.assert(value, lambda_1.isObject, "\"factory\" expects \"$when." + key + "\" on first argument to be an object, but was given \"" + lambda_1.toTypeString(value) + "\"");
    }
    lambda_1.assert(args.component, lambda_1.isFunction, "\"factory\" expects \"component\" on first argument to be a function, but was given \"" + lambda_1.toTypeString(args.component) + "\"");
    var factoryName = args.name, settings = args.settings, $when = args.$when;
    var variantFactory = args.component;
    var settingsDeclaration = {
        type: 'Object',
        properties: settings
    };
    var stateSettingsDeclaration = {
        type: 'Object',
        properties: Object.entries($when).reduce(function (acc, _a) {
            var _b;
            var key = _a[0], params = _a[1];
            return __assign(__assign({}, acc), (_b = {}, _b[key] = {
                type: 'Object',
                required: false,
                properties: params
            }, _b));
        }, {})
    };
    var validateDefaultSettings = type_guard_1.validate(settingsDeclaration);
    var validateVariantSettings = type_guard_1.partial(settingsDeclaration);
    var castSettings = type_guard_1.cast(settingsDeclaration);
    var validateStateSettings = type_guard_1.validate(stateSettingsDeclaration);
    var castStateSettings = type_guard_1.cast(stateSettingsDeclaration);
    var componentFactory = function (variants) {
        var _a;
        lambda_1.assert(variants, lambda_1.isObject, "Component factory \"" + factoryName + "\" expects first argument to be an object, but was given \"" + lambda_1.toTypeString(variants) + "\"");
        var _b = variants.default, defaultWhen = _b.$when, defaultSettings = __rest(_b, ["$when"]), customVariants = __rest(variants
        // Validate settings for default variation
        , ["default"]);
        // Validate settings for default variation
        var defaultValidation = validateDefaultSettings(defaultSettings);
        if (defaultValidation.length !== 0) {
            throw new TypeError("Component factory \"" + factoryName + "\" received invalid settings for variant \"default\": " + JSON.stringify(defaultValidation, undefined, 2));
        }
        // Validate and cast each state settings for default variation
        var defaultStateValidation = validateStateSettings(defaultWhen !== null && defaultWhen !== void 0 ? defaultWhen : {});
        if (defaultStateValidation.length !== 0) {
            throw new TypeError("Component factory \"" + factoryName + "\" received invalid settings for variant \"default.$when\": " + JSON.stringify(defaultStateValidation, undefined, 2));
        }
        var defaultComponent = (_a = {},
            _a[factoryName] = variantFactory({
                settings: castSettings(defaultSettings),
                $when: castStateSettings(defaultWhen !== null && defaultWhen !== void 0 ? defaultWhen : {})
            }),
            _a);
        defaultComponent[factoryName].displayName = factoryName;
        var customComponents = Object.entries(customVariants).reduce(function (acc, _a) {
            var _b;
            var _c = _a, variantName = _c[0], _d = _c[1], variantWhen = _d.$when, variantSettings = __rest(_d, ["$when"]);
            if (variantName.startsWith(factoryName) === false) {
                throw new TypeError("Component factory \"" + factoryName + "\" expects variant name to start with \"" + factoryName + "\", but was given \"" + variantName + "\"");
            }
            // Validate settings for variation
            var variantValidation = validateVariantSettings(variantSettings);
            if (variantValidation.length !== 0) {
                throw new TypeError("Component factory \"" + factoryName + "\" received invalid settings for variant \"" + variantName + "\": " + JSON.stringify(variantValidation, undefined, 2));
            }
            // Validate and cast each state settings for variation
            var variantStateValidation = validateStateSettings(variantWhen !== null && variantWhen !== void 0 ? variantWhen : {});
            if (variantStateValidation.length !== 0) {
                throw new TypeError("Component factory \"" + factoryName + "\" received invalid settings for variant \"" + variantName + ".$when\": " + JSON.stringify(variantStateValidation, undefined, 2));
            }
            var variantSettingsWithDefaults = __assign(__assign({}, defaultSettings), variantSettings);
            var castedVariantSettings = castSettings(variantSettingsWithDefaults);
            var castedVariantStateSettings = castStateSettings(variantWhen !== null && variantWhen !== void 0 ? variantWhen : {});
            var variantComponent = variantFactory({ settings: castedVariantSettings, $when: castedVariantStateSettings });
            variantComponent.displayName = variantName;
            return __assign(__assign({}, acc), (_b = {}, _b[variantName] = variantComponent, _b));
        }, {});
        var componentVariants = __assign(__assign({}, customComponents), defaultComponent);
        return componentVariants;
    };
    componentFactory.factoryName = factoryName;
    componentFactory.settingsDeclaration = settingsDeclaration;
    componentFactory.stateSettingsDeclaration = stateSettingsDeclaration;
    return componentFactory;
};
